export enum MigrateResultStatus {
  created = 'created',
  updated = 'updated',
  published = 'published',
  errors = 'errors',
  deleted = 'deleted',
}

export enum DataFormats {
  asset = 'asset',
  entry = 'entry',
  webpage = 'webpage',
}

const sys = {
  allUris: 'sys.allUris',
  contentTypeId: 'sys.contentTypeId',
  dataFormat: 'sys.dataFormat',
  filename: 'sys.properties.filename',
  id: 'sys.id',
  includeInSearch: 'sys.metadata.includeInSearch',
  language: 'sys.language',
  uri: 'sys.uri',
  versionStatus: 'sys.versionStatus',
};

export const Fields = {
  entryDescription: 'entryDescription',
  entryTitle: 'entryTitle',
  keywords: 'keywords',
  searchContent: 'searchContent',
  sys,
  contentTypeId: 'sys.contentTypeId',
  wildcard: '*',
};
